<template>
  <div>
    <div id="problemas-ativos" class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Problemas ativos"
            description="Condições ou alergias"
            url="/pre-natal"
            :enabledModalInformacao="true"
            :textModalInformacao="text"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="equipes"
              label="no_equipe"
              placeholder="Equipes"
              @input="onChangeEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_equipe }}
                {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
                @resetarNome="setRed = false"
              ></Subtitle>
            </div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="problemas-ativos"
              >
              </download-files>
            </div>
          </div>
          <tabela-cadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import Subtitle from './Subtitle'
import { infoHtml } from './utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'ProblemasAtivosPorEquipe',
  components: {
    PulseLoader,
    SectionTitle,
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      profissionais: [],
      profissional: '',
      loading: false,
      cadastros: [],
      cadastrosOriginais: [],
      setRed: false,
      text: infoHtml,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false, this.situacao)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true, this.situacao)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVerdes = false
      }
    },
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loading = true
        this.equipe = event
        try {
          //pega a equipe do acs
          let equipe = await this.$api.get(
            '/app/equipe/' +
              this.$store.state.cod_ibge +
              '/' +
              this.equipe.nu_ine
          )
          if (equipe) {
            let response = await this.$api.get(
              '/app/problemas-ativos/equipe/' +
                this.$store.state.cod_ibge +
                '/' +
                equipe.data.nu_ine
            )
            this.cadastros = []
            this.cadastros = response.data
            this.cadastrosOriginais = response.data
            this.filtros(true, false)
            this.setRed = true
            this.loading = false
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''
        return
      }
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.equipe)
    },
  },
  created() {},
}
</script>

<style scoped>
#problemas-ativos .info-table {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
  #problemas-ativos .info-table {
    gap: 10px;
  }
}
</style>
